import { loadZendeskWidget, hideZendeskWidget } from '@/utils/zendesk.utils'
import { onBeforeUnmount, onMounted } from 'vue'

export function useZendeskWidget() {
  onMounted(() => {
    loadZendeskWidget()
  })

  onBeforeUnmount(() => {
    hideZendeskWidget()
  })
}
